<div
  *ngIf="isOpen"
  class="cfm-backdrop"
  (click)="onBackdropClick($event)"
  tabindex="-1"
  role="presentation">
  <div
    class="cfm-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cfm-title"
    (click)="$event.stopPropagation()">
    <header class="cfm-header">
      <h2 id="cfm-title" class="cfm-title">
        <i class="fas fa-snowflake cfm-title-icon" aria-hidden="true"></i>
        Congelar contrato
      </h2>
      <button
        type="button"
        class="cfm-close"
        (click)="close()"
        [disabled]="isSubmitting"
        aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>
    </header>

    <div class="cfm-body">
      <p *ngIf="subtitle" class="cfm-contract-line">
        Contrato: <strong class="cfm-contract-strong">{{ subtitle }}</strong>
      </p>

      <div class="cfm-alert cfm-alert-info">
        <i class="fas fa-info-circle cfm-alert-icon" aria-hidden="true"></i>
        <p class="cfm-alert-text">
          Disponível para contratos <strong>vigentes</strong>, <strong>próximos ao vencimento</strong> ou
          <strong>aguardando pagamento</strong>. Não se aplica a cancelados, vencidos ou já congelados.
        </p>
      </div>

      <div class="cfm-alert cfm-alert-warn">
        <i class="fas fa-exclamation-triangle cfm-alert-icon" aria-hidden="true"></i>
        <p class="cfm-alert-text">
          <strong>Atenção — boletos:</strong> ao confirmar o congelamento, serão <strong>cancelados</strong> no Asaas
          apenas os <strong>boletos pendentes</strong> (em aberto) cuja data de vencimento estiver
          <strong>dentro do período</strong> definido abaixo (da data de início até o fim do congelamento).
          Boletos já pagos, fora desse intervalo ou outras formas de cobrança não entram nessa regra.
        </p>
      </div>

      <div class="cfm-form-grid">
        <div class="cfm-field">
          <label class="cfm-label" for="freezeStartDate">Início <span class="cfm-req">*</span></label>
          <input
            id="freezeStartDate"
            type="date"
            class="cfm-input"
            [(ngModel)]="startDateOnly"
            name="freezeStart" />
          <span class="cfm-hint">Abre com o dia atual; ajuste se precisar.</span>
        </div>

        <div class="cfm-field">
          <span class="cfm-label">Período <span class="cfm-req">*</span></span>
          <div class="cfm-segmented" role="group" aria-label="Período em dias">
            <button
              *ngFor="let d of dayOptions"
              type="button"
              class="cfm-segment-btn"
              [class.cfm-segment-btn-active]="daysPreset === d"
              (click)="setDaysPreset(d)">
              {{ d }} dias
            </button>
          </div>
          <span class="cfm-hint">Conta a partir da data de início acima.</span>
        </div>
      </div>

      <div *ngIf="validationMessage" class="cfm-alert cfm-alert-error">
        <i class="fas fa-exclamation-circle cfm-alert-icon" aria-hidden="true"></i>
        <p class="cfm-alert-text">{{ validationMessage }}</p>
      </div>
    </div>

    <footer class="cfm-footer">
      <button type="button" class="cfm-btn cfm-btn-cancel" (click)="close()" [disabled]="isSubmitting">
        Cancelar
      </button>
      <button type="button" class="cfm-btn cfm-btn-confirm" (click)="confirm()" [disabled]="isSubmitting">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm cfm-spinner" role="status"></span>
        <i *ngIf="!isSubmitting" class="fas fa-snowflake" aria-hidden="true"></i>
        Confirmar congelamento
      </button>
    </footer>
  </div>
</div>
